const c = (t, a) => {
  const e = new FormData();
  return Object.entries(a).forEach(([r, o]) => {
    e.append(r, o);
  }), fetch(t, {
    method: "POST",
    body: e,
    keepalive: !0
  });
};
export {
  c as default
};
